export const CAMPUS_LOOP_STOP_IDS = [
  'campus-inmundae',
  'campus-sh',
  'campus-ict',
  'campus-music',
  'campus-eng1',
  'campus-backgate',
  'campus-art',
  'campus-inmundae',
]

// 고색역 10:00은 학교 도착 후 교내 순환까지 이어서 운행하는 순환형 노선이다.
// gosaek-station → campus-inmundae(인문대 승차) 뒤에 CAMPUS_LOOP_STOP_IDS의
// 교내 순환 정류장을 그대로 재사용해 이어붙인다.
// CAMPUS_LOOP_STOP_IDS는 인문대로 시작해 인문대로 닫히지만(순환), 고색 10:00은
// 미술대학/조형관(campus-art)에서 종료하므로 마지막 닫힘 inmundae는 제외한다.
const GOSAEK_1000_STOP_IDS = [
  'gosaek-station',
  ...CAMPUS_LOOP_STOP_IDS.slice(0, -1),
]

export function getTripStopIds(routeId, departureTime, fallbackStopIds = [], options = {}) {
  if (routeId === 'campus_loop') return CAMPUS_LOOP_STOP_IDS
  if (routeId === 'gosaek_to_school' && departureTime === '10:00' && options.variant === 'campus_loop') {
    return GOSAEK_1000_STOP_IDS
  }
  return fallbackStopIds
}
